module.exports = __webpack_public_path__ + "static/getstarted3-cdec3279958182522b59b4067b2c19b3.jpg";